import React from 'react';
import { Field, reduxForm, change } from 'redux-form';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import MuiTextField from '../../../../../components/commons/fields/MuiTextField';
import GoogleAutocompleteField from '../../../../../components/commons/fields/GoogleAutocompleteField';

import translation from '../../../../../translation/translation';
import store from '../../../../../redux/store';
import validate from './validate';

class EditAddressForm extends React.Component {

  constructor(props) {
    super(props);

    this.handleAddressValue = this.handleAddressValue.bind(this);
  }

  handleAddressValue(addressObject) {

    if (!addressObject) return;

    store.dispatch(change('editAddressForm', 'address', addressObject.formatted_address));
  }

  render() {

    const {
      handleSubmit,
      editAction,
      mode
    } = this.props;

    return (
      <form onSubmit={handleSubmit} autoComplete='off'>
        <div className="EditAddressForm">
          <div className="field-wrapper">
            <Field
              type="text"
              id="adresse"
              name="address"
              label={translation().invoices.addresses.edit.form.labels.new_address}
              className="GoogleAutocompleteField"
              required={true}
              onSelect={this.handleAddressValue}
              component={GoogleAutocompleteField}
            />
          </div>
          <div className="field-wrapper">
            <Field
              name="name"
              type="text"
              label={translation().invoices.addresses.edit.form.labels.new_address_name}
              tabIndex="-1"
              required={true}
              component={MuiTextField}
            />
          </div>
          <div className="submit-wrapper">
            <Button
              color={mode && mode === "companies" ? "secondary" : "primary"}
              type="submit"
              style={{minWidth: 120}}
              disabled={editAction.loading}
              variant='contained'
            >
              {
                editAction.loading
                  ? <CircularProgress size={20} color='secondary' />
                  : <span>{translation().invoices.addresses.edit.form.buttons.submit}</span>
              }
            </Button>
          </div>
        </div>
      </form>
    );
  }
}

EditAddressForm.propTypes = {
  mode: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  editAction: PropTypes.shape({
    loading: PropTypes.bool,
  }).isRequired,
};

export default reduxForm({
  form: 'editAddressForm',
  validate
})(EditAddressForm);
